import conn from "@/store/utils/connection";
import customerGlobalAPI from "@/store/utils/api-route/customerGlobalAPI";
import resulter from "@/store/utils/resulter";
import state from "./state"

const actions = {
	queryFilter({rootGetters}) {
		let getFilter = rootGetters["filterGlobalModule/getFilter"]
		let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"]

		let query = {
			sort_by: getFilter.sortBy,
			order_by: getFilter.orderBy,
			limit: state.pagination.limit,
			offset: state.pagination.offset,
			kontak: getFilterItem.kontakKonsumen.length === 1 ? getFilterItem.kontakKonsumen[0] : "all",
		}
		// periode
		if (getFilterItem.periode.filterBy !== "") {
			query.filter_by = getFilterItem.periode.filterBy

			switch (getFilterItem.periode.filterBy) {
				case "periode":
					query.tanggal_awal = getFilterItem.periode.startDate
					query.tanggal_akhir = getFilterItem.periode.endDate
					break;
				case "bulan":
					query.bulan = getFilterItem.periode.month
					break;
				case "tahun":
					query.tahun = getFilterItem.periode.year
					break;
				default:
					break;
			}
		}
		// filter kolom
		getFilterItem.filterRentangTanggalKonsumenSnapclean !== "" ?
			query.filter_kolom = getFilterItem.filterRentangTanggalKonsumenSnapclean :
			query.filter_kolom = "periode_terdaftar"
		// filter layanan
		getFilterItem.filterLayananSnapcleanOwner !== "" ?
			query.filter_layanan_by = getFilterItem.filterLayananSnapcleanOwner :
			query.filter_layanan_by = "transaksi_semua_layanan"

		// layanan
		if (getFilterItem.layananSnapcleanOwner.length > 0) {
			query.idlayanan_array = getFilterItem.layananSnapcleanOwner
		}
		if (state.isSerachCustomerGlobal) {
			query.key = state.search.key
		}

		return query
	},

	async fetchCustomerGlobal({commit, dispatch}) {
		try {
			let query = await dispatch("queryFilter")

			const res = await conn.get(customerGlobalAPI.list, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				await conn.setQueryString(query)
				commit("setCustomerGlobal", res.data);
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchDetailCustomerGlobal({commit}, id) {
		try {
			let query = {
				idcustomerglobal: id
			}
			const res = await conn.get(customerGlobalAPI.detail, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setDetailCustomerGlobal", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchTopFive({commit}, id) {
		try {
			let query = {
				idcustomer_global: id
			}
			const res = await conn.get(customerGlobalAPI.topFive, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setTopFive", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	//
	async exportCustomerGlobal({rootGetters}) {
		let getFilter = rootGetters["filterGlobalModule/getFilter"]
		let query = {
			sort_by: getFilter.sortBy,
			order_by: getFilter.orderBy,
		}
		if (state.isSerachCustomerGlobal) {
			query.key = state.search.key
		}
		try {
			const res = await conn.get(customerGlobalAPI.export, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async exportCustomerGlobalTracker() {
		try {
			let query = {timestamp: Date.now()}
			const res = await conn.get(customerGlobalAPI.exportTrack, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult("", res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async deleteExportFileCustomerGlobal({commit}, filename) {
		try {
			let query = {filename: filename}
			const res = await conn.get(customerGlobalAPI.deleteExport, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult("", res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	// export v2
	async export({commit, dispatch}, payload) {
		try {
			let query = await dispatch("queryFilter")
			let formData = new FormData
			formData.append("type", payload.type)
			formData.append("filter_json", JSON.stringify(query))

			const res = await conn.post(customerGlobalAPI.export.job, formData, conn.contentType.form)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				let keyExport = "export:job:customer:global"
				localStorage.setItem("key_export_customer_snapclean", keyExport)
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportTrack({commit}) {
		try {
			let keyExport = localStorage.getItem("key_export_customer_snapclean")
			if (keyExport === null) {
				return resulter.errorResult()
			}
			let query = {
				key: keyExport
			}
			const res = await conn.get(customerGlobalAPI.export.track, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportDeleteCluster({commit}, key) {
		try {
			let query = {
				key: key
			}
			const res = await conn.get(customerGlobalAPI.export.delete.cluster, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportDeleteMaster({commit}) {
		// localStorage.removeItem("key_export_customer_snapclean")
		try {
			let keyExport = localStorage.getItem("key_export_customer_snapclean")
			let query = {
				key: keyExport
			}
			const res = await conn.get(customerGlobalAPI.export.delete.master, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				localStorage.removeItem("key_export_customer_snapclean")
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	}
}

export default actions